import { render, staticRenderFns } from "./shared-switch-info.vue?vue&type=template&id=2762a6f8&scoped=true"
import script from "./shared-switch-info.vue?vue&type=script&lang=js"
export * from "./shared-switch-info.vue?vue&type=script&lang=js"
import style0 from "./shared-switch-info.vue?vue&type=style&index=0&id=2762a6f8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2762a6f8",
  null
  
)

export default component.exports